import React from 'react';
import { AdminSidebar } from './navigation/AdminSidebar';
import { useAuth } from '../../auth/AuthContext';
import { LogOut, Bell, Menu } from 'lucide-react';
import { useSocial } from '../../social/SocialContext';
import { NotificationBell } from '../../../components/NotificationBell';

interface AdminLayoutProps {
  children: React.ReactNode;
  title?: string;
  actions?: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children, title, actions }) => {
  const { user, signOut } = useAuth();
  const { profile } = useSocial();

  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-slate-950">
      <AdminSidebar />

      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header className="h-16 px-4 sm:px-6 lg:px-8 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between sticky top-0 z-10">
            <div className="flex items-center gap-4">
                <button className="sm:hidden p-2 -ml-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800" title="Menu">
                    <Menu className="size-5 text-slate-600 dark:text-slate-400" />
                </button>
                <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100 truncate">
                    {title || 'Painel Administrativo'}
                </h1>
            </div>

            <div className="flex items-center gap-3">
                {actions}

                <div className="h-6 w-px bg-slate-200 dark:bg-slate-800 mx-1" />
                
                {user && profile && (
                  <NotificationBell userId={user.uid} userHandle={profile.handle} />
                )}

                <div className="relative group">
                    <button className="flex items-center gap-2 pl-2 rounded-full hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors" title="Perfil">
                        <div className="size-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-medium text-sm">
                            {user?.displayName?.[0] || 'A'}
                        </div>
                    </button>
                </div>
                
                <button 
                  onClick={async () => {
                    await signOut();
                    window.location.href = '/login';
                  }}
                  title="Sair"
                  className="p-2 rounded-lg hover:bg-red-50 hover:text-red-600 text-slate-500 transition-colors"
                >
                  <LogOut className="size-5" />
                </button>
            </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto w-full">
                {children}
            </div>
        </main>
      </div>
    </div>
  );
};
